import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { universityList } from "@/assets/universityList";
import { HERO_UNIVERSITIES } from "@/config/heroImages";
import Reveal from "@/components/Reveal";

/**
 * Public "Universities" page.
 */
const UniversitiesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <section
        className="relative bg-cover bg-center py-16 md:py-20"
        style={{ backgroundImage: `url(${HERO_UNIVERSITIES})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/40 to-[#ffa217]/20" />
        <div className="relative z-10 mx-auto max-w-3xl animate-fade-down px-4 text-center">
          <h1 className="text-4xl font-extrabold text-white md:text-5xl">
            {t("Universities")}
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-gray-200">
            {t("Uninfo HK serves students across all major Hong Kong universities.")}
          </p>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="mx-auto max-w-6xl px-4">
          <Reveal className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
            {universityList.map((uni) => (
              <div
                key={uni.value}
                className="flex items-center gap-4 rounded-2xl border border-gray-100 p-6 transition hover:border-[#ffa217] hover:shadow-lg"
              >
                <img
                  src={uni.image}
                  alt={t(uni.value)}
                  className="h-12 w-12 shrink-0 rounded-xl object-contain"
                />
                <div>
                  <div className="font-bold text-[#333]">{t(uni.value)}</div>
                  <div className="text-sm text-gray-500">{uni.label}</div>
                </div>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="bg-[#fff8f0] py-16">
        <Reveal className="mx-auto max-w-3xl px-4 text-center">
          <h2 className="text-3xl font-extrabold text-[#333]">
            {t("Your university not listed?")}
          </h2>
          <p className="mt-3 text-gray-600">
            {t("We are expanding all the time. Contact us to bring Uninfo to your campus.")}
          </p>
          <Link
            to="/contact"
            className="mt-6 inline-flex items-center gap-2 rounded-xl bg-[#ffa217] px-8 py-3 font-bold text-white transition hover:bg-[#e08f0e]"
          >
            {t("Contact Us")}
            <ArrowRight size={18} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
};

export default UniversitiesPage;